import { useState } from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { OneLineInput } from '../⚛️atoms/OneLineInput';
import {useTranslation} from "react-i18next";

export const ToolDrawerTools = () => {
  const tools = [{ name: 'Group Check-in', icon: <UserGroupIcon /> }];
  const [tool, setTool] = useState();
    const { t } = useTranslation();
  return (
    <div className="relative h-full w-full">
      <div className="flex flex-wrap py-10">
        {tools.map((tool) => (
          <button
            className="bg-pdteal/10 flex aspect-square w-1/3 flex-col items-center justify-center rounded-xl p-10 shadow-md hover:cursor-pointer hover:shadow-lg"
            onClick={() => setTool(tool.name)}
          >
            <div className="size-20">{tool.icon}</div>
            <span className="whitespace-nowrap">{tool.name}</span>
          </button>
        ))}
      </div>
      {tool === 'Group Check-in' && (
        <div className="absolute top-0 left-0 flex h-full w-full flex-col gap-y-20 overflow-y-auto bg-white px-5 pt-20 pb-10 shadow-lg">
          <button
            type="button"
            onClick={() => {
              setTool(null);
            }}
            className="absolute top-5 right-5 flex gap-3 rounded-md bg-white text-gray-400 hover:cursor-pointer hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
          >
            <div className="text-pddarkblue text-right text-lg leading-7 uppercase">{t('Close')}</div>
          </button>
          <OneLineInput label={t('What is the lowest level you reached on the FASTER Scale this week?')} />
          <OneLineInput label={t("What was the Double Bind you were dealing with?")} />
          <OneLineInput label={t("Where are you on your Commitment to Change from our last meeting?")} />
          <OneLineInput label={t("Have you lied to anyone this week either directly or indirectly?")} />
          <OneLineInput
            label={t("What have you done to improve your relationship with your wife or other significant relationships this week?")}
            labelClasses="-top-14 group-has-[:focus]:-top-16"
          />
        </div>
      )}
    </div>
  );
};
